'use strict';

module.exports = function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-widgets/~/dom-helpers/query/isWindow.js
// module id = 111
// module chunks = 0